/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import {
  PaymentRequestButtonElement,
  useStripe,
  Elements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { stripePublishableKey } from "../../utils/constant";

import { POST } from "../../config/https";
import APIS from "../../config/api";

import toast from "react-hot-toast";
import { usePersistentState } from "../../contexts/global-context";
import { useNavigate } from "react-router-dom";
import { STRING } from "../../resources/string";
import { GetLocalStorage } from "../../utils/local-storage";

export const Wallet: React.FC = () => {
  const navigate = useNavigate();
  const stripe = useStripe() as any | null;
  const [paymentRequest, setPaymentRequest] = useState<any>(null);
  const [paymentData, setPaymentData] = useState<any>({});
  const [state]: any = usePersistentState();

  const checkOutData = GetLocalStorage("CheckOutData");
  const checkOutDataEventDetail = GetLocalStorage("CheckOutDataEventDetail");
  const couponInfo = GetLocalStorage("CouponInfo");

  // When stripe becomes available, calculate amounts and create PaymentRequest
  useEffect(() => {
    if (stripe) {
      handleCheckOutAmount(1).catch((err) => {
        console.error("handleCheckOutAmount error:", err);
      });
    }
  }, [stripe]);

  // Create the PaymentRequest object and attach handler for "paymentmethod"
  const paymentRequestAndIntent = async (totalTicketPrice: number, data: any) => {
    // debugger;
    if (!stripe) return;
    const amountInCents = Math.round(totalTicketPrice * 100);

    const pr: any = stripe.paymentRequest({
      country: "US",
      currency: "usd",
      total: {
        label: "Total",
        amount: amountInCents,
      },
      requestPayerName: true,
      requestPayerEmail: true,
      requestShipping: false,
    });

    // Check availability (Apple Pay / Google Pay)
    const canPay = await pr.canMakePayment();
    if (canPay) {
      // Attach handler - stripe will call this when user authorizes payment
      pr.on("paymentmethod", (event: any) =>
        
        handleCreatePaymentIntent(event, data)
      );

      setPaymentRequest(pr);
    } else {
      // Payment Request (Apple/Google Pay) not available
      setPaymentRequest(null);
    }
  };

  // Calculate checkout amounts from your backend
  const handleCheckOutAmount = async (id: any) => {
    // debugger;
    try {
      const checkTemp = checkOutData;
      const ticketConfigs =
        checkTemp?.final?.map((x: any) => ({
          id: x?.id,
          qty: x?.qty,
        })) || [];

      const param = {
        couponCode: couponInfo?.couponCode,
        email: couponInfo?.email,
        eventId: state?.Event?.id,
        ticketConfigs,
        paymentType: id,
      };

      const res: any = await POST(APIS.CHARGE_CALCULATION, param);
      if (res?.isSuccess) {
        const totalTicketPrices = res?.result?.total || 0;
        await paymentRequestAndIntent(totalTicketPrices, res?.result);
        setPaymentData(res?.result || {});
      } else {
        console.error("Charge calculation failed:", res);
      }
    } catch (error) {
      console.error("handleCheckOutAmount error:", error);
    }
  };

  // Create order on your backend (checkout) using the payer info from Payment Request
  const handleCheckout = async (event: any, data: any) => {
    try {
      const checkoutPaymentData = GetLocalStorage("CheckOutData");
      const orderSummeryDtoData =
        checkoutPaymentData?.final?.map((x: any) => ({
          ticketConfigId: x?.id,
          ticketType: x?.ticketType,
          qty: x?.qty,
          price: x?.price,
        })) || [];

      // payerName may be empty or single name; handle robustly
      const fullName = event?.payerName || "";
      const parts = fullName.trim().split(/\s+/).filter(Boolean);
      let firstName = "";
      let lastName = "";
      if (parts.length === 0) {
        firstName = "Guest";
        lastName = "";
      } else if (parts.length === 1) {
        firstName = parts[0];
        lastName = "";
      } else {
        firstName = parts.slice(0, parts.length - 1).join(" ");
        lastName = parts[parts.length - 1];
      }

      const param = {
        customerDto: {
          firstName,
          lastName,
          phone: event?.payerPhone || checkoutPaymentData?.phone || 1234567891,
          email: event?.payerEmail || checkoutPaymentData?.email,
          amountDetail: {
            Total: checkoutPaymentData?.total,
            ServicePrice: checkoutPaymentData?.serviceFees,
            SubTotal: checkoutPaymentData?.subTotal,
            Tax: checkoutPaymentData?.tax,
          },
        },
        orderDto: {
          ServiceFees: checkoutPaymentData?.serviceFees,
          SubTotal: checkoutPaymentData?.subTotal,
          Tax: checkoutPaymentData?.tax,
          total: checkoutPaymentData?.total,
          eventId: checkOutDataEventDetail?.eventId,
          paymentTypeId: STRING.PAYMENT_TYPE_ID.CARD,
          discount: checkoutPaymentData?.couponDiscountPrice,
        },
        couponCode: state?.couponInfo?.couponCode,
        ordersItemDto: orderSummeryDtoData,
      };

      const res: any = await POST(APIS.CHECKOUT, param);
      if (res?.isSuccess) {
        // API sometimes returns misspelled keys (coustomerDetail), handle both
        const customerDetail =
          res?.result?.customerDetail || res?.result?.coustomerDetail || {};
        const orderDetail =
          res?.result?.orderDetail || res?.result?.orderDetail || {};

        // Update local checkout storage with returned details if needed
        const newData = {
          address: customerDetail?.email,
          firstName: customerDetail?.firstName,
          lastName: customerDetail?.lastName,
          phone: customerDetail?.phone,
        };

        const temp = {
          ...checkoutPaymentData,
          detail: newData,
          totalTicketPricesIncludeCouponPrice:
            orderDetail?.total ?? checkoutPaymentData?.total,
        };

        // If you want to save back to localStorage uncomment:
        // localStorage.setItem("CheckOutData", JSON.stringify(temp));

        return res?.result;
      } else {
        const errMsg =
          (res?.errors && res?.errors[0]) || "Checkout failed on server";
        toast.error(errMsg, { duration: 10000 });
        return null;
      }
    } catch (error: any) {
      console.error("handleCheckout error:", error);
      const errMsg =
        (error && (error.message || error?.errors?.[0])) || "Checkout error";
      toast.error(errMsg, { duration: 10000 });
      return null;
    }
  };  

  // Handler invoked by stripe PaymentRequest's "paymentmethod" event
  const handleCreatePaymentIntent = async (event: any, data: any) => {
    // debugger;
    if (!stripe) {
      toast.error("Stripe not loaded");
      try {
        await event.complete("fail");
      } catch {}
      return;
    }

    // The "event" object contains payerName, payerEmail, paymentMethod, etc.
    try {
      // 1) Create order in your system
      const order = await handleCheckout(event, data);
      if (!order) {
        await event.complete("fail");
        return;
      }

      // 2) Build product list & payment intent params
      const productDto =
        checkOutData?.final?.map((x: any) => ({
          Name: x?.ticketType,
          DefaultPrice: x?.price,
          Created: x?.createdDate,
          UnitLabel: x?.qty,
        })) || [];

      const clientEmail = event?.payerEmail || paymentRequest?.payerEmail;

      const amountVal = checkOutData?.totalTicketPrices ?? checkOutData?.total ?? 0;

      const param = {
        paymentMethodId: event?.paymentMethod?.id,
        Products: productDto,
        Email: clientEmail,
        Currency: "USD",
        Amount: amountVal,
        CustomerId:
          order?.customerDetail?.id || order?.coustomerDetail?.id || null,
        OrderId: order?.orderDetail?.id || null,
        AmountDetail: {
          Total: checkOutData?.totalTicketPrices,
          ServiceFees: checkOutData?.serviceFees,
          SubTotal: checkOutData?.subTotal,
          Tax: checkOutData?.tax,
          CouponDiscountPrice: checkOutData?.couponDiscountPrice,
        },
        couponCode: state?.couponInfo?.couponCode,
        OrderNumber:
          order?.orderDetail?.orderNumber || order?.orderDetail?.orderNumber,
      };
      // 3) Create intent on backend
      const res: any = await POST(APIS.CREATE_INTENT, param);
      const clientSecret = res?.result?.client_secret || res?.result?.clientSecret || null;
      if (!clientSecret) {
        await event.complete("fail");
        const errMsg = (res?.errors && res?.errors[0]) || "Unable to create payment intent";
        toast.error(errMsg);
        return;
      }
      // Update the Status

      // 4) Confirm payment using the paymentMethod from the Payment Request event
      const confirmResult: any = await stripe.confirmCardPayment(clientSecret, { payment_method: event?.paymentMethod?.id });

      if (confirmResult?.error) {
        // Payment failed
        await event.complete("fail");
        toast.error("Payment failed: " + (confirmResult.error.message || ""));
        console.error("confirmResult.error:", confirmResult.error);
        return;
      }

      // Payment succeeded
      await event.complete("success");

      // Navigate to success page with required query params
      navigate(
        `/checkout-successful?payment_intent=${confirmResult.paymentIntent.id}&payment_intent_client_secret=${encodeURIComponent(
          clientSecret
        )}&redirect_status=succeeded`,
        { replace: true }
      );

      toast.success("Payment Success");
    } catch (error: any) {
      console.error("handleCreatePaymentIntent error:", error);
      try {
        await event.complete("fail");
      } catch {}
      toast.error(error?.message || "Payment processing failed");
    }
  };

  // Render Payment Request button if available - otherwise show fallback.
  if (paymentRequest) {
    return (
      <div>
        <PaymentRequestButtonElement
          options={{ paymentRequest }}
          // style can be customized here if you want
        />
      </div>
    );
  }

  // Fallback UI when Payment Request API (Apple/Google Pay) is not available
  return (
    <div>
      {/* <p>Quick pay (Apple/Google Pay) not available on this device/browser.</p> */}
      {/* Fallback: Provide a regular checkout link/button. Update route as per your app */}
      {/* <button
        onClick={() => {
          
          navigate("/checkout", { replace: false });
        }}
        className="btn"
      >
        Continue to card checkout
      </button> */}
    </div>
  );
};

const stripePromise = loadStripe(stripePublishableKey);

const WalletInput: React.FC = () => {
  return (
    <Elements stripe={stripePromise}>
      <Wallet />
    </Elements>
  );
};

export default WalletInput;
